import PropTypes from "prop-types";
import { ErrorPage } from "../../components/error-page";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

export const ErrorPageContainer = ({
  errorType,
  sheerIdProgramId,
  sheerIdLocale,
}) => {
  const translate = useTranslate(useLocaleProvider());
  return (
    <>
      {errorType === "sheerId" ? (
        <ErrorPage
          title={translate("sv_error_heading")}
          description={translate("sv_sheerid_error_desc")}
          buttonText={translate("sv_sheerid_error_cta")}
          onClick={() =>
            window.open(
              `https://offers.sheerid.com/sheerid/help-center/?pid=${sheerIdProgramId}&locale=${sheerIdLocale}`,
              "_blank"
            )
          }
        />
      ) : (
        <ErrorPage
          title={translate("sv_error_heading")}
          description={translate("sv_internal_error_desc")}
          buttonText={translate("sv_internal_error_cta")}
          onClick={() => (window.location.href = "/student-validation")}
        />
      )}
    </>
  );
};

ErrorPageContainer.propTypes = {
  errorType: PropTypes.string.isRequired,
  sheerIdProgramId: PropTypes.string.isRequired,
  sheerIdLocale: PropTypes.string.isRequired,
};
